import React, { useEffect, createElement } from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { ServicesSection } from '../components/ServicesSection';
import { ProcessSection } from '../components/ProcessSection';
import { LocalAuthoritySection } from '../components/LocalAuthoritySection';
import { BlogSection } from '../components/BlogSection';
import { FinalCtaSection } from '../components/FinalCtaSection';
import { useSeo } from '../components/useSeo';
export function HomePage() {
  useSeo({
    title: 'Webdesign voor Financiële Dienstverleners in Alkmaar & Amsterdam | Noord',
    description: 'Vaste prijs vooraf, lokaal aanspreekpunt en een structurele klantenstroom uit Google. Wij bouwen websites voor accountants en financieel adviseurs (1-5 medewerkers).',
    canonical: 'https://noorddigital.nl/',
    jsonLd: [{
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'Noord Digital',
      url: 'https://noorddigital.nl/'
    }, {
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      name: 'Noord Digital',
      description: 'Webdesign en SEO voor financiële dienstverleners in Alkmaar en Amsterdam.',
      url: 'https://noorddigital.nl/',
      telephone: '+31616265214',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Schuit 8a',
        addressLocality: 'Oudkarspel',
        postalCode: '1724 BD',
        addressCountry: 'NL'
      }
    }]
  });
  return <main data-id="element-1088" data-mp="20q5u7r5vutqk">
      <HeroSection data-id="element-1089" data-mp="20pnsif0gbnb9" />
      <ProblemSection data-id="element-1090" data-mp="20p4a6x6w2wwp" />
      <ServicesSection data-id="element-1091" data-mp="20ss0zoky957q" />
      <ProcessSection data-id="element-1092" data-mp="25pikklvyqixw" />
      <LocalAuthoritySection data-id="element-1093" data-mp="25q1zdtqbgr7p" />
      <BlogSection data-id="element-1094" data-mp="25r3ec9agdxup" />
      <FinalCtaSection data-id="element-1095" data-mp="25nfk17x6p7ex" />
    </main>;
}